import { Box, Typography } from "@mui/material";
import { Stack, styled } from "@mui/system";
import img from "../../assets/Images/bh_2.png";

export const CloseButtonWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  paddingTop: "10px",
  paddingRight: "10px",
});

export const CloseButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50px",
  height: "30px",
  width: "30px",
  background: "white",
  cursor: "pointer",
});

export const ModalWrapper = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  zIndex: 1,
  backgroundColor: "white",
  backgroundImage: `url(${img})`, // Replace with the actual image path
  backgroundSize: "100% 100%", // Makes the image cover the entire area
  backgroundRepeat: "no-repeat", // Prevents tiling
  backgroundPosition: "center", // Replace with static color
  boxShadow: "24px",
  maxWidth: "550px",
  padding: "0!important",
  paddingTop: "10px",
  paddingBottom: "50px",
});

export const Header = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: "8px",
  padding: "12px 32px 16px",
});

export const Divider = styled(Box)({
  height: "1px",
  background: "#EAF1FA",
});

export const Content = styled(Box)({
  display: "flex",
  flexDirection: "column",
  //   gap: "8px",
  padding: "0 32px",
  marginTop: "8px",
  marginBottom: "42px",
  //   paddingBottom: 0,
});

export const InstructionWrapper = styled(Box)({
  padding: "0 16px 16px",
});

export const Title = styled(Typography)({
  fontSize: "28px",
  fontWeight: 600,
  color: "#01060B",
});

export const Description = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  color: "#2C3034",
});

export const ButtonWrapper = styled(Box)({
  padding: " 0 36px",
});

export const StyledErrorMessage = styled(Box)({
  color: "red",
  fontWeight: 400,
  textAlign: "left",
  padding: "0px 0px 10px 0px",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  // width: "60%", // Adjust width as needed
});
export const StyledTypographyLLc = styled(Typography)<{ isFont?: boolean }>(({ theme, isFont }) => ({
  color: "#060110",
  fontSize: isFont ? "16px" : "18px",
  fontWeight: isFont ? 500 : 600,
  marginBottom: isFont ? "10px" : "0px",
  // paddingBottom: theme.spacing(2), // Uncomment if needed
}));
